export const PageToolbar = ({children}) => <div className="admin-toolbar">{children}</div>;

export const ToolbarInput = ({label, ...props}) => (
    <label className="admin-field">
        <span>{label}</span>
        <input {...props} />
    </label>
);

export const ToolbarSelect = ({label, children, ...props}) => (
    <label className="admin-field">
        <span>{label}</span>
        <select {...props}>{children}</select>
    </label>
);

export const ToolbarButton = ({children, variant = "primary", ...props}) => (
    <button className={`admin-button admin-button-${variant}`} type="button" {...props}>
        {children}
    </button>
);
